import { NgIf } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { BrandService } from '@app/shared/services/brand/brand.service';

@Component({
  selector: 'app-sidebar',
  imports: [RouterModule, NgIf],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit, OnDestroy {
  public brandService = inject(BrandService);
  isSidebarOpen = false;
  isHeaderFixed = false;
  private routerSub!: Subscription;

  constructor(private router: Router) {}

  ngOnInit(): void {
    // Escuchamos los cambios de ruta
    this.routerSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Si está en mobile y el sidebar está abierto, lo cerramos
        if (window.innerWidth < 992 && this.isSidebarOpen) {
          this.isSidebarOpen = false;
        }
      }
    });
  }

  toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (window.innerWidth < 992) {
      this.isHeaderFixed = window.scrollY > 150;
    } else {
      this.isHeaderFixed = false;
    }
  }

  ngOnDestroy(): void {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }
}
